module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glyphicon glyphicon-floppy-disk"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-476f9985","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SaveIcon.vue
// module id = 443
// module chunks = 1